/**
 * Contact-avatar gradient rotation (neumorphic redesign).
 *
 * The design handoff specifies five 145° avatar gradients cycled across
 * contacts. The CSS classes live in `src/index.css` (`.neu-avatar-0` …
 * `.neu-avatar-4` — literal classes so Tailwind's JIT scanner is not
 * involved at all); this helper picks one deterministically.
 *
 * STABILITY: the pick is a hash of the CONTACT's id (callers pass
 * `conversation.contact.id`), so a given contact keeps the same gradient
 * across sessions, list reorderings, and both the conversation row and the
 * chat header. A simple 31-multiplier string hash is plenty — we only need
 * a stable bucket in [0, 5), not uniformity guarantees.
 */

const AVATAR_GRADIENT_CLASSES = [
  'neu-avatar-0',
  'neu-avatar-1',
  'neu-avatar-2',
  'neu-avatar-3',
  'neu-avatar-4',
] as const;

/** Stable gradient class for a contact key (e.g. `contact.id`). */
export function avatarGradientClass(key: string): string {
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  }
  return AVATAR_GRADIENT_CLASSES[hash % AVATAR_GRADIENT_CLASSES.length];
}
